"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportableComponent = ExportableComponent;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _ConnectorObjectExporter = require("./ConnectorObjectExporter");
var _DownloadExportationPopup = _interopRequireDefault(require("./DownloadExportationPopup"));
var _ImportResumePopup = require("./ImportResumePopup");
var _ExportMenu = require("./ExportMenu");
var _ConnectorObjectImporter = require("./ConnectorObjectImporter");
var _ConnectorTemplateDownloader = require("./ConnectorTemplateDownloader");
var _ConnectorObjectImporter2 = require("./ConnectorObjectImporter.types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ExportableComponent(props) {
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    gridAnchorEl = _useState2[0],
    setGridAnchorEl = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    popup = _useState4[0],
    setPopup = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    importResponse = _useState6[0],
    setImportResponse = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    exportResponse = _useState8[0],
    setExportResponse = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    templateResponse = _useState10[0],
    setTemplateResponse = _useState10[1];
  var onClickedMore = function onClickedMore(event) {
    setGridAnchorEl(event.currentTarget);
  };
  var openFileImport = function openFileImport() {
    setGridAnchorEl(null);
    setPopup('Import');
  };
  var onDownloadTemplate = function onDownloadTemplate() {
    setGridAnchorEl(null);
    setPopup('Template');
  };
  var handleUpload = function handleUpload(files) {
    if (files.length === 0) {
      return;
    }
    setPopup(undefined);
    feedbackContext.showBackdrop((0, _core.translate)('importable.importing'));
    props.getImportPromise(files[0], props.tenantId).then(function (response) {
      setImportResponse(response);
      props.onImported();
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  var onExportWithParams = function onExportWithParams() {
    setGridAnchorEl(null);
    if (props.total) {
      setPopup('ExportFiltered');
    } else {
      feedbackContext.showWarning((0, _core.translate)('exportable.empty'));
    }
  };
  var onExportSelected = function onExportSelected() {
    setGridAnchorEl(null);
    if (props.selectedIds.length) {
      setPopup('ExportSelected');
    } else {
      feedbackContext.showWarning((0, _core.translate)('exportable.no_selection'));
    }
  };
  var downloadWithConnector = function downloadWithConnector(connectorId, startDate, endDate) {
    if (!popup) return;
    var promise;
    if (popup === 'ExportSelected') {
      promise = props.getExportSelectedPromise(connectorId, props.tenantId);
    } else {
      promise = props.getExportWithParamsPromise(connectorId, props.tenantId, startDate, endDate);
    }
    onClose();
    feedbackContext.showBackdrop((0, _core.translate)('exportable.exporting'));
    promise.then(function (response) {
      if (response.url) {
        setExportResponse(response);
      } else if (response.total) {
        feedbackContext.showSuccess((0, _core.translate)('exportable.email', {
          total: response.total
        }));
      } else {
        feedbackContext.showWarning((0, _core.translate)('exportable.empty'));
      }
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  var downloadTemplateWithConnector = function downloadTemplateWithConnector(connectorId) {
    if (!popup) return;
    onClose();
    feedbackContext.showBackdrop((0, _core.translate)('exportable.exporting'));
    props.getTemplatePromise(connectorId, props.tenantId).then(function (response) {
      setTemplateResponse(response);
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  var onClose = function onClose() {
    setPopup(undefined);
  };
  var onCompleted = function onCompleted() {
    setImportResponse(undefined);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    color: "inherit",
    size: "small",
    edge: "start",
    onClick: onClickedMore
  }, /*#__PURE__*/_react["default"].createElement(_commons.EllipsisIcon, null)), gridAnchorEl && /*#__PURE__*/_react["default"].createElement(_ExportMenu.ExportMenu, {
    createAction: props.createAction,
    getAction: props.getAction,
    anchor: gridAnchorEl,
    items: props.items,
    onDownloadTemplate: onDownloadTemplate,
    onImport: openFileImport,
    onExportSelected: onExportSelected,
    onExportWithParams: onExportWithParams,
    onClose: function onClose() {
      return setGridAnchorEl(null);
    }
  }), (popup === 'ExportSelected' || popup === 'ExportFiltered') && /*#__PURE__*/_react["default"].createElement(_ConnectorObjectExporter.ConnectorObjectExporter, {
    type: popup === 'ExportFiltered' && props.allowDates ? 'DATA_RANGE' : 'DATA',
    tenantId: props.tenantId,
    familyId: props.familyId,
    onExport: downloadWithConnector,
    onClose: onClose
  }), popup === 'Import' && /*#__PURE__*/_react["default"].createElement(_ConnectorObjectImporter.ConnectorObjectImporter, {
    tenantId: props.tenantId,
    onUploaded: handleUpload,
    onClose: onClose,
    extensions: _ConnectorObjectImporter2.ETL_EXTENSIONS
  }), popup === 'Template' && /*#__PURE__*/_react["default"].createElement(_ConnectorTemplateDownloader.ConnectorTemplateDownloader, {
    tenantId: props.tenantId,
    familyId: props.familyId,
    onExport: downloadTemplateWithConnector,
    onClose: onClose
  }), exportResponse && exportResponse.url && /*#__PURE__*/_react["default"].createElement(_DownloadExportationPopup["default"], {
    title: (0, _core.translate)('exportable.title'),
    message: (0, _core.translate)('exportable.found'),
    url: exportResponse.url,
    onClose: function onClose() {
      return setExportResponse(undefined);
    }
  }), templateResponse && templateResponse.url && /*#__PURE__*/_react["default"].createElement(_DownloadExportationPopup["default"], {
    title: (0, _core.translate)('importable.template_downloader.title'),
    message: (0, _core.translate)('importable.template_downloader.text'),
    url: templateResponse.url,
    onClose: function onClose() {
      return setTemplateResponse(undefined);
    }
  }), importResponse && /*#__PURE__*/_react["default"].createElement(_ImportResumePopup.ImportResumePopup, {
    summary: importResponse,
    onClose: onCompleted,
    elements: props.importResultElements
  }));
}